/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import "./Landing.css";
import { Image } from "@fluentui/react-components";
import { Button } from "@fluentui/react-components";
import HMSAPP from "../../assets/images/VerticalAccordion-1-1-656x504.avif";
import {
    ShareRegular,
    ArrowLeftRegular,
    ArrowRightRegular,
    CommentRegular,
    AddRegular,
    MicFilled
} from '@fluentui/react-icons';
import cilpron_logo from "../../assets/images/cilpron.jpeg";
import {
    CarouselSlider,
    Field,
    makeStyles,
    Switch,
    tokens,
    typographyStyles,
} from "@fluentui/react-components";
import {
    Carousel,
    CarouselAnnouncerFunction,
    CarouselAutoplayButtonProps,
    CarouselCard,
    CarouselNav,
    CarouselNavButton,
    CarouselNavContainer,
    CarouselViewport,
} from "@fluentui/react-components";
import Messages from "../Communication/Message";
import { useNavigate } from "react-router-dom";


const CarouselItems = (handleNext: () => void, handlePrev: () => void, handleLoginBtn: () => void) => [
    <>
        <div className="px-slides__slide-wrapper px-slides__slide-wrapper--selected">
            <div className="px-slides-transition px-slides-transition--active px-slides__transitioner" style={{ opacity: '1' }}>
                <div className="px-slides__slide">
                    <div className="slide-grid slide-grid--can-scroll slide-default slide-default--selected slide-page__slide slide-page__slide--selected _tene3bn3j">
                        <div className="slide-grid__grid">
                            <div className="slide-grid__left slide-grid__slot">
                                <div className="slide-grid-column slide-grid-column--mode-block _notransition slide-grid-column--bottom slide-default__left">
                                    <div className="slide-grid-column__content _content-resource">
                                        <div className="slide-grid-column__content-wrapper slide-grid-column__content-wrapper--bottom">
                                            <div className="slide-default__left-top">
                                                <div className="mini-block-container mini-block-container--mode-block">
                                                    <div className="mini-block-container__blocks ALLIGNMENT_287H">
                                                        <div style={{ marginBottom: '1em' }}>
                                                            <h2 className="px-balanced-text mini-block-text mini-block-text--default mini-block-text--mode-block mini-block-text--page-type-slide mini-block-text--heading" style={{ textAlign: 'start' }}>
                                                                <span className="px-balanced-text__inner px-balanced-text__inner--html h2" style={{ maxWidth: '351.77px' }}>
                                                                    <p>Start with <em>intuitive dashboards</em></p>
                                                                </span>
                                                            </h2>
                                                        </div>
                                                        <div style={{ marginBottom: '2em' }}>
                                                            <div className="px-balanced-text mini-block-text mini-block-text--default mini-block-text--mode-block mini-block-text--page-type-slide mini-block-text--body" style={{ textAlign: 'start' }}>
                                                                <span className="px-balanced-text__inner px-balanced-text__inner--html sh2" style={{ maxWidth: '423.492px' }}>
                                                                    <p>Manage properties effortlessly with AI-powered automation and insights.</p>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="action-list mini-block-actions">
                                                            <div className="action-browser-feature">
                                                                <Button onClick={handleLoginBtn} icon={<ShareRegular />} className="common-button-v1 common-button-v1--rel-sm common-button-v1--temp-secondary-1 action-browser-feature__button action-browser-feature__button">
                                                                    <span className="common-button-v1__content">
                                                                        <span className="common-button-v1__label">View Accounts</span>
                                                                    </span>
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="slide-grid-column__bottom">
                                            <div className="slide-grid-column__bottom-backdrop-container">
                                                <div className="slide-grid-column__bottom-backdrop"></div>
                                            </div>
                                            <div className="slide-default__left-bottom">
                                                <div className="mini-block-container mini-block-container--mode-block">
                                                    <div className="mini-block-container__blocks" style={{ alignItems: 'start', justifyContent: 'center', textAlign: 'start' }}>
                                                        <div style={{ width: '100%' }}>
                                                            <div className="slide-next-button slide-next-button--prev-visible slide-default__button-next" style={{ justifyContent: 'start' }}>
                                                                {/* next and previous button */}
                                                                <Button onClick={handlePrev} icon={<ArrowLeftRegular />} className="common-button-v1 common-button-v1--next common-button-v1--noarrow common-button-v1--temp-next-6-arrow common-button-v1--next-prev slide-next-button__prev slide-next-button__prev"></Button>
                                                                <Button onClick={handleNext} className="common-button-v1 common-button-v1--next common-button-v1--temp-next-6-arrow common-button-v1--next-prev slide-next-button__next slide-next-button__next">
                                                                    <span className="common-button-v1__label">Next</span>
                                                                    <ArrowRightRegular />
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-grid__right slide-grid__slot">
                                <div className="slide-grid-column slide-grid-column--mode-flex slide-default__right">
                                    <div className="slide-grid-column__content">
                                        <div className="slide-grid-column__content-wrapper slide-default__right-content">
                                            <div className="mini-block-container mini-block-container--fill mini-block-container--mode-contain">
                                                <div className="mini-block-container__blocks" style={{ alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                                                    <div className="mini-block-media" style={{ minHeight: '1em', flex: '1 1 0%', maxHeight: '531px' }}>
                                                        <div className="media-item-image media-item-image--default media-item-image--align-x-center media-item-image--align-y-center mini-block-media__media">
                                                            <div className="px-contain media-item-image__contain media-item-image__contain--enabled">
                                                                <div className="media-item-frame media-item-frame--rounded-sm media-item-frame--shadow media-item-image__frame _Nexts size-controle">
                                                                    <div className="common-media-placeholder media-item-image__placeholder">
                                                                        <Image
                                                                            src={HMSAPP}
                                                                            height={200}
                                                                            width={200}
                                                                            style={{ marginTop: '-50px' }}
                                                                            shape="rounded" />

                                                                    </div>
                                                                    <div className="action-browser-feature media-item-image__action media-item-image-dead-click">
                                                                        <button className="common-button-v1 common-button-v1--hotspot action-browser-feature__button action-browser-feature__button">
                                                                            <span className="common-button-v1__content">
                                                                                <span className="common-button-v1__label">Click</span>
                                                                            </span>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>,
    <>
        <div className="px-slides__slide-wrapper px-slides__slide-wrapper--selected">
            <div className="px-slides-transition px-slides-transition--active px-slides__transitioner" style={{ opacity: '1' }}>
                <div className="px-slides__slide">
                    <div className="slide-grid slide-grid--can-scroll slide-default slide-default--selected slide-page__slide slide-page__slide--selected _tene3bn3j">
                        <div className="slide-grid__grid">
                            <div className="slide-grid__left slide-grid__slot">
                                <div className="slide-grid-column slide-grid-column--mode-block _notransition slide-grid-column--bottom slide-default__left">
                                    <div className="slide-grid-column__content _content-resource">
                                        <div className="slide-grid-column__content-wrapper slide-grid-column__content-wrapper--bottom">
                                            <div className="slide-default__left-top">
                                                <div className="mini-block-container mini-block-container--mode-block">
                                                    <div className="mini-block-container__blocks ALLIGNMENT_287H">
                                                        <div style={{ marginBottom: '1em' }}>
                                                            <h2 className="px-balanced-text mini-block-text mini-block-text--default mini-block-text--mode-block mini-block-text--page-type-slide mini-block-text--heading" style={{ textAlign: 'start' }}>
                                                                <span className="px-balanced-text__inner px-balanced-text__inner--html h2" style={{ maxWidth: '351.77px' }}>
                                                                    <p>Find <em>Hospitality solutions</em></p>
                                                                </span>
                                                            </h2>
                                                        </div>
                                                        <div style={{ marginBottom: '2em' }}>
                                                            <div className="px-balanced-text mini-block-text mini-block-text--default mini-block-text--mode-block mini-block-text--page-type-slide mini-block-text--body" style={{ textAlign: 'start' }}>
                                                                <span className="px-balanced-text__inner px-balanced-text__inner--html sh2" style={{ maxWidth: '423.492px' }}>
                                                                    <p>Build exceptional guest and staff relationships and a more adaptable back office.</p>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="action-list mini-block-actions">
                                                            <div className="action-browser-feature">
                                                                <Button onClick={handleLoginBtn} icon={<ShareRegular />} className="common-button-v1 common-button-v1--rel-sm common-button-v1--temp-secondary-1 action-browser-feature__button action-browser-feature__button">
                                                                    <span className="common-button-v1__content">
                                                                        <span className="common-button-v1__label">View Accounts</span>
                                                                    </span>
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="slide-grid-column__bottom">
                                            <div className="slide-grid-column__bottom-backdrop-container">
                                                <div className="slide-grid-column__bottom-backdrop"></div>
                                            </div>
                                            <div className="slide-default__left-bottom">
                                                <div className="mini-block-container mini-block-container--mode-block">
                                                    <div className="mini-block-container__blocks" style={{ alignItems: 'start', justifyContent: 'center', textAlign: 'start' }}>
                                                        <div style={{ width: '100%' }}>
                                                            <div className="slide-next-button slide-next-button--prev-visible slide-default__button-next" style={{ justifyContent: 'start' }}>
                                                                {/* next and previous button */}
                                                                <Button icon={<ArrowLeftRegular />} className="common-button-v1 common-button-v1--next common-button-v1--noarrow common-button-v1--temp-next-6-arrow common-button-v1--next-prev slide-next-button__prev slide-next-button__prev"></Button>
                                                                <Button className="common-button-v1 common-button-v1--next common-button-v1--temp-next-6-arrow common-button-v1--next-prev slide-next-button__next slide-next-button__next">
                                                                    <span className="common-button-v1__label">Next</span>
                                                                    <ArrowRightRegular />
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-grid__right slide-grid__slot">
                                <div className="slide-grid-column slide-grid-column--mode-flex slide-default__right">
                                    <div className="slide-grid-column__content">
                                        <div className="slide-grid-column__content-wrapper slide-default__right-content">
                                            <div className="mini-block-container mini-block-container--fill mini-block-container--mode-contain">
                                                <div className="mini-block-container__blocks" style={{ alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                                                    <div className="mini-block-media" style={{ minHeight: '1em', flex: '1 1 0%', maxHeight: '531px' }}>
                                                        <div className="media-item-image media-item-image--default media-item-image--align-x-center media-item-image--align-y-center mini-block-media__media">
                                                            <div className="px-contain media-item-image__contain media-item-image__contain--enabled">
                                                                <div className="media-item-frame media-item-frame--rounded-sm media-item-frame--shadow media-item-image__frame _Nexts size-controle">
                                                                    <div className="common-media-placeholder media-item-image__placeholder">
                                                                        <Image
                                                                            src={HMSAPP}
                                                                            height={200}
                                                                            width={200}
                                                                            style={{ marginTop: '-50px' }}
                                                                            shape="rounded" />

                                                                    </div>
                                                                    <div className="action-browser-feature media-item-image__action media-item-image-dead-click">
                                                                        <button className="common-button-v1 common-button-v1--hotspot action-browser-feature__button action-browser-feature__button">
                                                                            <span className="common-button-v1__content">
                                                                                <span className="common-button-v1__label">Click</span>
                                                                            </span>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
]

interface LandingProps {
    onButtonClick: () => void;
  }
  
  const Landing: React.FC<LandingProps> = ({ onButtonClick }) =>{
    const [activeIndex, setActiveIndex] = useState(0);
    const [isVisible, setIsVisible] = useState(false);
    const navigate = useNavigate();

   const handleLoginBtn = () => {
    onButtonClick();
     navigate('/login');
   }

    const toggleVisibility = () => {
        setIsVisible(!isVisible);
    };

const handlCloseChat = () => {
    setIsVisible(false);
}

    const handleNext = () => {
        setActiveIndex((activeIndex + 1) % 2);
    };

    const handlePrev = () => {
        setActiveIndex((activeIndex - 1 + 2) % 2);
    };

    useEffect(() => {
        const intervalId = setInterval(() => {
            handleNext();
        }, 3000); // Adjust autoplay interval as needed

        return () => clearInterval(intervalId); // Cleanup interval on component unmount
    }, [handleNext]);

    const handleNavClick = (index: number) => {
        setActiveIndex(index);
    };

    const CarouseItems = CarouselItems(handleNext, handlePrev, handleLoginBtn);

    // const [activeIndex, setActiveIndex] = useState(0);
    // const handleNext = () => {
    //     setActiveIndex((activeIndex + 1) % CarouselItems.length);
    //   };

    //   const handlePrev = () => {
    //     setActiveIndex((activeIndex - 1 + CarouselItems.length) % CarouselItems.length);
    //   };

    //   const handleNavClick = (index: number) => {
    //     setActiveIndex(index);
    //   };




    // useEffect(() => {
    //     const intervalId = setInterval(() => {
    //         setActiveIndex(prevIndex => (prevIndex + 1) % CarouselItems.length);
    //     }, 10000); // Adjust autoplay interval as needed

    //     return () => clearInterval(intervalId); // Cleanup interval on component unmount
    // }, [CarouselItems.length]);



    return (
        <>
            <div className="body-overlay slide-page slide-page--ready slide-page--theme-default fluent fluent--dark slides-page">
                <div className="UWNRE-273BD">
                    <div className="slide-background slide-page__background blur-inner">
                        <div className="slide-grid slide-background__grid">
                            <div className="slide-grid__grid">

                            </div>
                            <div className="px-slides px-slides--orientation-horizontal px-slides--anchored slide-page__slides">
                                <Carousel groupSize={1} circular>
                                    <CarouselViewport>
                                        <CarouselSlider
                                            style={{
                                                transform: `translateX(-${activeIndex * 100}%)`,
                                                transition: 'transform 0.5s ease-in-out'
                                            }}
                                        >
                                            {CarouseItems.map((item, index) => (
                                                <CarouselCard
                                                    key={`item-${index}`}
                                                    aria-label={`Item ${index + 1}`}
                                                >
                                                    {item}
                                                </CarouselCard>
                                            ))}
                                        </CarouselSlider>
                                    </CarouselViewport>
                                </Carousel>

                                {/* Carousel Slider */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="UWNRE-273BD slide-nav slide-nav--dropdown slide-nav--numbered-expand slide-nav--area-media slide-nav--page-theme-default slide-page__nav">
                    <div className="slide-nav__inner" aria-busy="true" role="tablist">
                        <div className="slide-nav__title">

                            <Button className="slide-nav__nav-item slide-nav__nav-item--title" role="tab" aria-label="Here's what's new in Microsoft Edge" data-bi-id="Link-Navigate-Navbar-Intro">
                                <div className="slide-nav__icon">
                                    <Image src={cilpron_logo} alt="" style={{ height: '100%' }} />
                                </div>
                                <span className="slide-nav__nav-item-label color-blue">Discover more with Cilpron</span>
                            </Button>
                        </div>
                        <div className="slide-nav__items slide-nav__items--align-end">
                            <div className="px-fit slide-nav__fit slide-nav__fit--align-end">
                                <div className="px-fit__outer">
                                    <div className="slide-nav__nav-items slide-nav__nav-items--align-end">
                                        {CarouseItems.map((_, index) => (
                                            <Button
                                                key={`nav-${index}`}
                                                className={`slide-nav__nav-item slide-nav__nav-item--nav slide-nav__nav-item--fit-lg ${index === activeIndex ? 'slide-nav__nav-item--selected' : ''}`}
                                                onClick={() => handleNavClick(index)}
                                            >
                                                <span className="slide-nav__nav-item-counter">{index + 1}</span>
                                                <span className={`slide-nav__nav-item-label ${index === activeIndex ? 'slide-nav__nav-item-label--selected' : ''}`}></span>
                                            </Button>
                                        ))}
                                        <div className="slide-nav__selection-bar" style={{ left: `${activeIndex * 100}%`, width: 'calc(100% / CarouselItems.length)' }}></div>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-nav__separator" aria-hidden="true"></div>
                            <div className="slide-nav__separator" aria-hidden="true"></div>
                            {!isVisible && (
                                <div className="slide-nav__addons">
                                    <div className="slide-nav-addon">
                                        <div className="embed-cilpron-prompt embed-cilpron-prompt--dark">
                                            <div className="embed-cilpron-prompt__container">
                                                <div className="embed-cilpron-prompt__container-background"></div>
                                                <div className="embed-cilpron-prompt__container-foreground" onClick={toggleVisibility}>
                                                    <CommentRegular className="dark-color" />
                                                    <AddRegular className="dark-color" />
                                                    <div className="embed-cilpron-prompt__text-area">
                                                        <div className="embed-cilpron-prompt__prompt">Ask your question</div>
                                                    </div>
                                                    <MicFilled className="dark-color" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {/* AI CHAT */}
            {isVisible && (
                <>
                    <div className="Messages-CEH3">
                        <Messages HandleToggleVisibility={handlCloseChat} />
                    </div>
                </>
            )}

        </>
    )
}

export default Landing;